import React, { useCallback, useContext } from "react";
import { Request } from "../api/plant/Plant.api";
import { AuthContext } from "../context/auth/AuthContext";
import DetailPlantContainer from "../containers/plants/DetailPlantContainer";
import Detail from "../views/plants/DetailPlant";

const PlantPage = ({ item }) => {
  const { token } = useContext(AuthContext);
  const onRefresh = useCallback(() => {
    Request.refreshPlant(token, item.id);
    Request.refreshPlants(token);
  }, [token, item.id]);

  return (
    <DetailPlantContainer id={item.id}>
      {({ content }) => <Detail onRefresh={onRefresh} plant={content} />}
    </DetailPlantContainer>
  );
};

export default PlantPage;
